import { render } from "./ShowcasePrices.vue?vue&type=template&id=6cbaa36a&scoped=true"
import script from "./ShowcasePrices.vue?vue&type=script&lang=js"
export * from "./ShowcasePrices.vue?vue&type=script&lang=js"

import "./ShowcasePrices.vue?vue&type=style&index=0&id=6cbaa36a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbaa36a"]])

export default __exports__